// extracted by mini-css-extract-plugin
var _1 = "FeedComment_line__884f6";
var _2 = "FeedComment_root__bd151";
var _3 = "FeedComment_title__98e60";
export { _1 as "line", _2 as "root", _3 as "title" }
